const BASE = process.env.PUBLIC_URL || "";

/** Prefix app assets (logo, catalog images) with the deploy subdirectory. */
export function publicUrl(path) {
  if (!path) return path;
  if (/^https?:\/\//i.test(path) || path.startsWith("data:")) return path;
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${BASE}${p}`;
}

export const routerBasename = BASE;
